import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";


@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  private baseUrl = environment.apiUrl + "/api/v1/promotions";

  constructor(private http: HttpClient,) { }

  save(data: any, id) {
    if (id)
      return this.http.put<any>(this.baseUrl + "/" + id, data)
    else
      return this.http.post<any>(this.baseUrl, data)
  }

} 
